import dayjs from 'dayjs';

import { API_DATE_FORMAT, DEFAULT_DATE_FORMAT } from '../appConstants';

export const displayDate = (
  date: string | null,
  format = DEFAULT_DATE_FORMAT,
  fromFormat = API_DATE_FORMAT,
): string => {
  if (date && dayjs(date, fromFormat).isValid()) {
    return dayjs(date, fromFormat).format(format);
  }

  return '';
};

export const isDateTimeBefore = (
  date: Date | string,
  value: number,
  unit: 'hours' | 'minutes' | 'seconds',
): boolean => {
  const dateTimeAfterCreation = dayjs(date).add(value, unit);
  return dayjs(new Date()).isBefore(dateTimeAfterCreation);
};
